// extracted by mini-css-extract-plugin
export default {"root":"Aes7nw","bg":"H9nTT1"};